export const categories = [
  {
    name: "Overview",
    fullName: "Viewpoints",
    icon: "/icons/overview.svg",
    list: [
      // { name: "NTM", link: "X", clickable: false },
      { name: "VP A", link: "VP1", clickable: true },
      { name: "VP B", link: "VP2", clickable: true },
      { name: "VP C", link: "VP3", clickable: true },
      { name: "VP D", link: "VP4", clickable: true },
    ],
  },
  {
    name: "Air Quality",
    fullName: "Air Quality",
    icon: "/icons/air.svg",
    list: [

      {
        name: "VP A",
        link: "VP1",
        clickable: true,
        triggerOverlayName: "main_air",
        hasData: true,
      },
      {
        name: "VP B",
        link: "VP2",
        clickable: true,
        triggerOverlayName: "main_air",
        hasData: true,
      },
      {
        name: "VP C",
        link: "VP3",
        clickable: true,
        triggerOverlayName: "main_air",
        hasData: true,
      },
      {
        name: "VP D",
        link: "VP4",
        clickable: true,
        triggerOverlayName: "main_air",
        hasData: true,
      },

    ],
  },
  {
    //>> noise list
    name: "Noise",
    fullName: "Noise",
    icon: "/icons/noise.svg",
    list: [
      {
        name: "VP A",
        link: "VP1",
        clickable: true,
        triggerOverlayName: "main_road_noise",
        hasData: true,
      },
      {
        name: "VP B",
        link: "VP2",
        clickable: true,
        triggerOverlayName: "main_road_noise",
        hasData: true,
      },
      {
        name: "VP C",
        link: "VP3",
        clickable: true,
        triggerOverlayName: "main_road_noise",
        hasData: true,
      },
      {
        name: "VP D",
        link: "VP4",
        clickable: true,
        triggerOverlayName: "main_road_noise",
        hasData: true,
      },
    ],
    //>> marine traffic list
    // marine_list: [
    //   {
    //     name: "TKO 132",
    //     link: "X",
    //     clickable: false,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: null,
    //   },
    //   {
    //     name: "VP B1",
    //     link: "VPB1",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: true,
    //   },
    //   {
    //     name: "VP B2",
    //     link: "VPB2",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: true,
    //   },
    //   {
    //     name: "VP B3",
    //     link: "VPB3",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: true,
    //   },
    //   {
    //     name: "TKO 137",
    //     link: "X",
    //     clickable: false,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: null,
    //   },
    //   {
    //     name: "VP A1",
    //     link: "VPA1",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: true,
    //   },
    //   {
    //     name: "VP A2",
    //     link: "VPA2",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: false,
    //   },
    //   {
    //     name: "VP A3",
    //     link: "VPA3",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: false,
    //   },
    //   {
    //     name: "VP A4",
    //     link: "VPA4",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: false,
    //   },
    //   {
    //     name: "VP A5",
    //     link: "VPA5",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: false,
    //   },
    //   {
    //     name: "VP A6",
    //     link: "VPA6",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: false,
    //   },
    //   {
    //     name: "VP A7",
    //     link: "VPA7",
    //     clickable: true,
    //     triggerOverlayName: "main_marine_noise",
    //     hasData: false,
    //   },
    // ],
  },

  {
    name: "Ecology",
    fullName: "Habitat Map",
    icon: "/icons/ecology.svg",
    list: [],
  },

  // {
  //   name: "Odour",
  //   fullName: "Odour",
  //   icon: "/icons/water.svg",
  //   list: [],
  // },
  {
    name: "Visual",
    fullName: "Landscape & Visual",
    icon: "/icons/visual.svg",
    list: [
      { name: "VP1", link: "VP1", clickable: true },
      { name: "VP2", link: "VP2", clickable: true },
      { name: "VP3", link: "VP3", clickable: true },
      { name: "VP4", link: "VP4", clickable: true },
      { name: "VP5A", link: "VP5A", clickable: true },
      { name: "VP5B", link: "VP5B", clickable: true },
      { name: "VP6", link: "VP6", clickable: true },
      { name: "VP7", link: "VP7", clickable: true },


    ],
  },
  // {
  //   name: "Other Aspects",
  //   fullName: "Other Aspects",
  //   icon: "/icons/three-dots.svg",
  //   list: [],
  // },
];
